import { ApiResponse } from "@ocktra/shared-types";
import { apiClient } from "../services/api";



async function disconnectConnection(connectionId: string): Promise<ApiResponse<void>> {
    // Placeholder for disconnect logic
    console.log(`Disconnecting connection with ID: ${connectionId}`);

    const response=await apiClient.post<ApiResponse<void>>('/provider/delete',{
        connectionId
    });

    console.log(`Disconnected connection with ID: ${connectionId}`);

    return response
}

async function deleteConnection(connectionId: string): Promise<ApiResponse<void>> {
    // Placeholder for delete logic
    const response=await apiClient.post<ApiResponse<void>>(`/provider/delete`,{
        connectionId
    });

    console.log(`Deleting connection with ID: ${connectionId}`);

    return response
}

export { disconnectConnection, deleteConnection };
